import { SET_APP_MENU } from '../actions/const';

const initialState = {
	resetState: false,
	showModal: false,
	isLoadingAction: false,

	selectedData: null,
	formType: '',
	formId: '',
	formTitle: '',

	name: '',
	label: '',
	isEpicMillions: false,
	url: '',
	browser: {
		label: 'Internal',
		value: 'INTERNAL',
	},
	isUseGoogleChrome: false,
	icon: null,
	isNew: false,
	position: {
		label: 'Top',
		value: 'TOP',
	},
	sort: 0,

	cardType: [],
	excludedCardType: [],
	specificUser: [],
	blacklistedUser: [],
	deviceType: {
		label: 'All',
		value: 'ALL',
	},
	isUploadingCSVFile: false,
	isUploadingCSVFileBlacklistedUser: false,

	deviceTypeOptions: [
		{
			label: 'ALL',
			value: 'ALL',
		},
		{
			label: 'ANDROID',
			value: 'ANDROID',
		},
		{
			label: 'IOS',
			value: 'IOS',
		},
	],

	showModalConfig: false,
	isSavingConfig: false,
	isLoadingConfig: false,
	isActive: false,
	appMenuConfig: null,
};

function reducer(state = initialState, action) {
	let { type, payload } = action;

	switch (type) {
		case SET_APP_MENU:
			if (typeof action.payload.resetState !== 'undefined' && action.payload.resetState) {
				action.payload = { ...initialState };
			}
			return Object.assign({}, state, action.payload);
			break;

		default: {
			return state;
		}
	}
}

module.exports = reducer;



// WEBPACK FOOTER //
// ./reducers/AppMenu.js